<template>
  <v-container>
    <h2>Create address</h2>
    <v-row>
      <v-col lg="10" md="12" sm="12">
        <app-search
          :attribute_list="search_attribute"
          @setSearchParam="setSearchParam"
        />
        <app-list
          :search_param="search_param"
          @setCustomerId="setCustomerId"
        />
        <div v-if="address.customer_id">
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="address.firstname"
                label="Firstname"
                :rules="[rules.require]"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="address.lastname"
                label="Lastname"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="address.company_name"
                label="Company name"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="address.company_branch"
                label="Company branch"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="address.tax_id"
                label="Tax ID"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-textarea
                v-model="address.address_detail"
                label="Address detail"
                outlined
                dense
                height="80"
                :rules="[rules.require]"
              ></v-textarea>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="address.address_sub_district"
                label="Sub-district"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="address.address_district"
                label="District"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="address.address_country"
                label="Country"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="address.address_postal_code"
                label="Postal code/zipcode"
                outlined
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="address.phone_number"
                label="Phone number"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            color="orange"
            dark
            @click="createAddress"
          >
            Create
          </v-btn>
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'address-list' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "AddressCreate",
  components: { 
    AppSearch: () => import('../components/customer.search'),
    AppList: () => import('../components/customer.list'),
  },
  data: () => ({
    customer_email: null,
    address: {
      firstname: null,
      lastname: null,
      company_name: null,
      company_branch: null,
      tax_id: null,
      address_detail: null,
      address_sub_district: null,
      address_district: null,
      address_province: null,
      address_country: null,
      address_postal_code: null,
      phone_number: null,
      customer_id: null
    },
    search_attribute: ['firstname', 'lastname', 'company_name', 'company_branch',
      'tax_id', 'address_detail', 'address_sub_district', 'address_district',
      'address_province', 'address_country', 'address_postal_code'],
    search_param: '',
    rules: {
      require: value => !!value || 'Please fill in information',
      personal_id: value => !value || value.length < 14 || 'Tax ID must have 13 digits',
    },
  }),
  methods: {
    async setSearchParam (val) {
      this.search_param = val
      this.address.customer_id = null
      this.address.firstname = null
      this.address.lastname = null
      this.address.company_name = null
      this.address.company_branch = null
      this.address.tax_id = null
      this.address.address_detail = null
      this.address.address_sub_district = null
      this.address.address_district = null
      this.address.address_province = null
      this.address.address_country = null
      this.address.address_postal_code = null
      this.address.phone_number = null
    },
    setCustomerId (customer) {
      this.search_param = ''
      this.address.customer_id = customer.id
      this.address.firstname = customer.firstname
      this.address.lastname = customer.lastname
      this.address.phone_number = customer.phone_number
    },
    async createAddress () {
      try {
        if (this.requireField()) {
          await this.$http.post(`/back-office/addresses`, this.address, authHeader())
          this.$router.push({ name: 'address-list'})
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () {
      if (!this.address.customer_id) {
        alert('Please select customer')
        return false;
      }
      if (!this.address.firstname) {
        alert('Please fill in firstname')
        return false;
      }
      if (!this.address.address_detail) {
        alert('Please fill in address detail')
        return false;
      }
      return true
    }
  },
};
</script>
